import type { HomepageExtraCard, HomepageRegistryCard } from '@korvo/core/components/homepage/NormalHomepage'
import { NormalHomepage } from '@korvo/core/components/homepage/NormalHomepage'

export type DashboardHomePageProps = {
  /** Extra cards to show in the app grid (e.g. Admin for admin users) */
  extraCards?: HomepageExtraCard[]
  /** Installed app cards (same grid; icon may be URL or Remix icon class) */
  registryCards?: HomepageRegistryCard[]
}

/** Logged-in module grid / marketing homepage shell (canonical app hub is `/home` + `DashboardPage`). */
export function DashboardHomePage({ extraCards = [], registryCards = [] }: DashboardHomePageProps = {}) {
  return <NormalHomepage extraCards={extraCards} registryCards={registryCards} />
}

/** @deprecated Use {@link DashboardHomePage}. */
export const AppHomePage = DashboardHomePage
/** @deprecated Use {@link DashboardHomePageProps}. */
export type AppHomePageProps = DashboardHomePageProps

